import matches from 'validator/lib/matches';
import { createField, updateField } from '../../actions';
import { EVENT_STEP_VALIDATE } from '../../helpers/consts';

export class AddressField {
    constructor(options) {
        this.validateMessages = {
            isEmpty: __('Please enter your house number'),
            noPostalCode: __('This is not a house number'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id );
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;
        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.validate();
        }
    }

    createFieldElement () { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $combinedField = document.createElement('div');
        const $combinedFieldFirst = document.createElement('div');
        const $combinedFieldSecond = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldAddressNumberInput = document.createElement('input');
        this.$fieldAddressSuffixInput = document.createElement('input');
        this.$fieldMessage = document.createElement('span');

        // Number part of the postal code
        this.$fieldAddressNumberInput.type = 'text';
        this.$fieldAddressNumberInput.required = this.required;
        this.$fieldAddressNumberInput.maxLength = 7;
        this.$fieldAddressNumberInput.id = `${this.id}--number`;
        this.$fieldAddressNumberInput.value = this.value ? this.value.replace(/(^[0-9-]+)([a-zA-Z]*[a-zA-Z0-9\s-]{0,5}$)/i,'$1') : ''; // 123BIS -> 123

        // Letter part of the postal code
        this.$fieldAddressSuffixInput.type = 'text';
        this.$fieldAddressSuffixInput.placeholder = '';
        this.$fieldAddressSuffixInput.maxLength = 10;
        this.$fieldAddressSuffixInput.id = `${this.id}--suffix`;
        this.$fieldAddressSuffixInput.value = this.value ? this.value.replace(/(^[0-9-]+)([a-zA-Z]*[a-zA-Z0-9\s-]{0,5}$)/i,'$2') : ''; // 123BIS -> BIS

        $fieldLabel.setAttribute('for', `${this.id}--number`);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--address');
        $combinedField.classList.add('row');
        $combinedFieldFirst.classList.add('col-6');
        $combinedFieldSecond.classList.add('col-6');
        $fieldLabel.classList.add('field-label');
        this.$fieldAddressNumberInput.classList.add('field-input', 'form-control', 'field-input--address-number');
        this.$fieldAddressSuffixInput.classList.add('field-input', 'form-control', 'field-input--address-suffix');
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');

        $field.appendChild($fieldLabel);
        $combinedFieldFirst.appendChild(this.$fieldAddressNumberInput);
        $combinedFieldSecond.appendChild(this.$fieldAddressSuffixInput);
        $combinedField.append($combinedFieldFirst);
        $combinedField.append($combinedFieldSecond);

        $field.appendChild($combinedField);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldAddressNumberInput.addEventListener('blur', this.validate.bind(this));
        this.$fieldAddressNumberInput.addEventListener('input', () => {
            this.$fieldAddressNumberInput.value = this.$fieldAddressNumberInput.value.replace(/[^0-9-]/, '');
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        this.$fieldAddressSuffixInput.addEventListener('input', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    setValue() {
        this.$fieldAddressNumberInput.value = ''
        this.$fieldAddressSuffixInput.value = '';
        this.validate();
    }

    getValue() {
        return this.$fieldAddressNumberInput.value + this.$fieldAddressSuffixInput.value;
    }

    getNumber() {
        return this.$fieldAddressNumberInput.value;
    }

    getSuffix() {
        return this.$fieldAddressSuffixInput.value;
    }

    validate() {
        this.$fieldAddressNumberInput.classList.remove('is-invalid');
        this.$fieldAddressNumberInput.classList.remove('is-valid');
        this.isValid = false;

        if (this.$fieldAddressNumberInput.value === '') {
            if (this.required) {
                this.$fieldAddressNumberInput.classList.add('is-invalid');
                this.isValid = false;
                this.$fieldMessage.innerHTML = this.validateMessages.isEmpty.replace(/%s/g, this.label);
            }

            this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
            return;
        }

        if(matches(this.getValue(), /^([1-9][0-9]*-?[0-9]*)([a-zA-Z]{0,5}[a-zA-Z0-9\s-]{0,5}$)/i)) { // 123BIS or 88e10 or 12kamer24
            // Valid address
            this.$fieldAddressNumberInput.classList.remove('is-invalid');
            this.$fieldAddressNumberInput.classList.add('is-valid');
            this.isValid = true;
        } else {
            // No html allowed
            this.$fieldAddressNumberInput.classList.add('is-invalid');
            this.$fieldMessage.innerHTML = this.validateMessages.noPostalCode;

            return;
        }

        this.store.dispatch(updateField(this.id, this.getValue(), this.isValid, this.label));
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default AddressField;
